import { createSlice } from "@reduxjs/toolkit";
import { 
  fetchSubscriptionPlanModuleTableColumns,
  fetchAllSubscriptionPlanModules,
  addSubscriptionPlanModule,
  updateSubscriptionPlanModule,
  deleteSubscriptionPlanModule,
  activateDeactivateSubscriptionPlanModule
} from "./thunk";

const initialState = {
  modules: [],
  tableColumnNames: [],
  loading: false,
  error: null,
};

const SubscriptionPlanModuleSlice = createSlice({
  name: "SubscriptionPlanModules",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

    .addCase(fetchSubscriptionPlanModuleTableColumns.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchSubscriptionPlanModuleTableColumns.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
    })
    .addCase(fetchSubscriptionPlanModuleTableColumns.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(fetchAllSubscriptionPlanModules.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchAllSubscriptionPlanModules.fulfilled, (state, action) => {
        state.loading = false;
        state.modules = action.payload;
    })
    .addCase(fetchAllSubscriptionPlanModules.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(addSubscriptionPlanModule.pending, (state) => {
        state.error = null;
    })
    .addCase(addSubscriptionPlanModule.fulfilled, (state, action) => {
        state.modules.unshift(action.payload);
    })
    .addCase(addSubscriptionPlanModule.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(updateSubscriptionPlanModule.pending, (state) => {
        state.error = null;
    })
    .addCase(updateSubscriptionPlanModule.fulfilled, (state, action) => {
        const index = state.modules.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.modules[index] = action.payload;
        }
    })
    .addCase(updateSubscriptionPlanModule.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(deleteSubscriptionPlanModule.pending, (state) => {
        state.error = null;
    })
    .addCase(deleteSubscriptionPlanModule.fulfilled, (state, action) => {
        state.modules = state.modules.filter(
            (item) => item.ID !== action.payload[0].ID
        );
    })
    .addCase(deleteSubscriptionPlanModule.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(activateDeactivateSubscriptionPlanModule.pending, (state) => {
        state.error = null;
    })
    .addCase(activateDeactivateSubscriptionPlanModule.fulfilled, (state, action) => {
        const index = state.modules.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.modules[index] = action.payload;
        }
    })
    .addCase(activateDeactivateSubscriptionPlanModule.rejected, (state, action) => {
        state.error = action.payload;
    })
  },
});

export default SubscriptionPlanModuleSlice.reducer;
